<template>
  <v-dialog v-model="dialog" max-width="850px" persistent @keydown.esc="close">
    <v-card>
      <v-toolbar dark color="primary">
        <v-icon class="mr-2">qr_code</v-icon>
        <v-toolbar-title>Crear Código de Acceso QR</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon color="red" @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <!-- Info reserva -->
        <v-layout row wrap class="mb-2">
          <v-flex xs12 sm6 class="pr-2">
            <v-text-field
              :value="reservation && reservation.owner_company_name"
              label="Empresa dueña"
              prepend-icon="business"
              readonly
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 class="pl-2">
            <v-text-field
              :value="formatReservationPeriod()"
              label="Período de la reserva"
              prepend-icon="date_range"
              readonly
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-divider class="my-3"></v-divider>

        <!-- Selector: Nuevo Transportista o existente -->
        <div v-if="!isPrivate" class="mb-4">
          <p class="subheading grey--text mb-2">Tipo de visitante</p>
          <v-radio-group v-model="providerMode" row mandatory>
            <v-radio label="Transportista existente" value="existing"></v-radio>
            <v-radio label="Nuevo Transportista" value="new"></v-radio>
          </v-radio-group>
        </div>

        <v-divider class="my-3"></v-divider>

        <v-form ref="form" v-model="formValid">
          <v-layout row wrap>

            <!-- Columna izquierda -->
            <v-flex xs12 md6 class="pr-3">
              <p class="subheading grey--text mb-2">Datos del acceso</p>

              <v-select
                v-model="formData.parking_space_id"
                :items="availableSpaces"
                item-text="display_name"
                item-value="parking_space"
                label="Cajón de parqueo"
                prepend-icon="local_parking"
                :rules="[rules.required]"
              ></v-select>

              <!-- OPCIÓN A: Seleccionar Transportista existente -->
              <v-autocomplete
                v-if="!isPrivate && providerMode === 'existing'"
                v-model="formData.provider_id"
                :items="providers"
                item-text="display_name"
                item-value="id"
                label="Seleccionar Transportista"
                prepend-icon="person"
                :rules="[rules.required]"
                @change="onProviderSelected"
              >
                <template v-slot:item="data">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ data.item.display_name }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ data.item.telephone }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>

              <!-- OPCIÓN B: Crear nuevo Transportista -->
              <template v-if="!isPrivate && providerMode === 'new'">
                <v-text-field
                  v-model="formData.first_name"
                  label="Nombre"
                  prepend-icon="person"
                  :rules="[rules.required]"
                ></v-text-field>

                <v-text-field
                  v-model="formData.last_name"
                  label="Apellido (opcional)"
                  prepend-icon="person"
                ></v-text-field>
              </template>
            </v-flex>

            <!-- Columna derecha -->
            <v-flex v-if="!isPrivate" xs12 md6 class="pl-3">
              <p class="subheading grey--text mb-2">Contacto y vehículo</p>

              <v-text-field
                v-model="formData.email"
                label="Email (opcional)"
                prepend-icon="email"
                type="email"
              ></v-text-field>

              <v-layout row align-center>
                <v-flex xs5 class="pr-2">
                  <v-select
                    v-model="formData.phone_code"
                    :items="phoneCodes"
                    item-text="label"
                    item-value="code"
                    label="Lada"
                    prepend-icon="flag"
                  ></v-select>
                </v-flex>
                <v-flex xs7>
                  <v-text-field
                    v-model="formData.phone"
                    label="Teléfono"
                    prepend-icon="phone"
                    type="tel"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-text-field
                v-model="formData.plates"
                label="Placas (opcional)"
                prepend-icon="directions_car"
              ></v-text-field>

              <v-text-field
                v-model="formData.unit_specs"
                label="Modelo / Especificaciones (opcional)"
                prepend-icon="local_shipping"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <template v-if="isPrivate">
            <v-alert :value="!!capacityError" type="warning">{{ capacityError }}</v-alert>
            <p class="caption grey--text" v-if="maxProviders">Hasta {{ maxProviders }} proveedores para este cajón. Se generará un QR por proveedor.</p>
            <v-card v-for="(entry, index) in providerEntries" :key="entry.key" flat class="pa-3 mb-3 grey lighten-5">
              <div class="layout align-center">
                <span class="body-2 font-weight-bold">Proveedor {{ index + 1 }}</span>
                <v-spacer></v-spacer>
                <v-btn icon small :disabled="providerEntries.length === 1 || loading" @click="providerEntries.splice(index, 1)"><v-icon small>delete</v-icon></v-btn>
              </div>
              <v-radio-group v-model="entry.mode" row>
                <v-radio label="Proveedor existente" value="existing"></v-radio>
                <v-radio label="Nuevo proveedor" value="new"></v-radio>
              </v-radio-group>
              <v-autocomplete v-if="entry.mode === 'existing'" v-model="entry.provider_id" :items="providers" item-text="display_name" item-value="id" label="Proveedor" :loading="loadingProviders" :rules="[rules.required]"></v-autocomplete>
              <v-layout v-else row wrap>
                <v-flex xs12 sm6 class="px-2"><v-text-field v-model="entry.first_name" label="Nombre" :rules="[rules.required]"></v-text-field></v-flex>
                <v-flex xs12 sm6 class="px-2"><v-text-field v-model="entry.last_name" label="Apellido"></v-text-field></v-flex>
                <v-flex xs12 sm6 class="px-2"><v-text-field v-model="entry.email" label="Correo" type="email"></v-text-field></v-flex>
                <v-flex xs12 sm6 class="px-2">
                  <v-layout row align-center>
                    <v-flex xs5 class="pr-2">
                      <v-select v-model="entry.phone_code" :items="phoneCodes" item-text="label" item-value="code" label="Lada"></v-select>
                    </v-flex>
                    <v-flex xs7>
                      <v-text-field v-model="entry.phone" label="Teléfono" type="tel"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6 class="px-2"><v-text-field v-model="entry.plates" label="Placas"></v-text-field></v-flex>
                <v-flex xs12 sm6 class="px-2"><v-text-field v-model="entry.unit_specs" label="Modelo / Especificaciones"></v-text-field></v-flex>
              </v-layout>
            </v-card>
            <v-btn flat color="primary" :disabled="loading || loadingCapacity || providerEntries.length >= maxProviders" @click="addProviderEntry">Agregar proveedor</v-btn>
          </template>

          <v-divider class="my-3"></v-divider>

          <v-layout row wrap>
            <!-- Vigencia -->
            <v-flex xs12 md6 class="pr-3">
              <p class="subheading grey--text mb-2">Vigencia del código</p>

              <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" offset-y lazy>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formData.invitation_date"
                    label="Fecha inicio"
                    prepend-icon="event"
                    readonly
                    :rules="[rules.required, rules.dateInReservation]"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="formData.invitation_date" @input="startMenu = false"></v-date-picker>
              </v-menu>

              <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" offset-y lazy>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formData.expiration"
                    label="Fecha fin"
                    prepend-icon="event"
                    readonly
                    :rules="[rules.required, rules.expirationAfterStart, rules.dateInReservation]"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="formData.expiration" @input="endMenu = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Descripción y Opciones -->
            <v-flex xs12 md6 class="pl-3">
              <p class="subheading grey--text mb-2">Descripción y Opciones</p>

              <v-text-field
                v-model="formData.subject"
                label="Asunto / Descripción"
                prepend-icon="note"
                counter="256"
              ></v-text-field>

              <v-select
                v-if="!isPrivate"
                v-model="formData.num_vehicles"
                :items="[1, 2, 3]"
                label="Cantidad de vehículos"
                prepend-icon="directions_car"
                :rules="[rules.numVehicles]"
                type="number"
              ></v-select>

              <v-checkbox
                :input-value="true"
                disabled
                label="Activar código inmediatamente"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="primary" @click="close">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" :disabled="isPrivate && (loadingCapacity || !maxProviders)" @click="submit">
          Crear Código QR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/utils/errorHandler'

export default {
  name: 'QRCodeDialog',
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    reservation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      providerEntries: [],
      entryKey: 0,
      maxProviders: 0,
      loadingCapacity: false,
      capacityError: '',
      capacityRequest: 0,
      providerMode: 'existing',
      providers: [],
      loadingProviders: false,
      formValid: false,
      startMenu: false,
      endMenu: false,
      formData: {
        reservation_id: null,
        parking_space_id: null,
        provider_id: null,
        invitation_date: '',
        expiration: '',
        subject: '',
        notes: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_code: '+52',
        phone: '',
        plates: '',
        unit_specs: '',
        activate_immediately: true,
        num_vehicles: 1
      },
      loading: false,
      phoneCodes: [
        { code: '+52', label: '+52 MX' },
        { code: '+1', label: '+1 USA/CA' },
        { code: '+54', label: '+54 AR' },
        { code: '+55', label: '+55 BR' },
        { code: '+56', label: '+56 CL' },
        { code: '+57', label: '+57 CO' },
        { code: '+503', label: '+503 SV' },
        { code: '+502', label: '+502 GT' },
        { code: '+504', label: '+504 HN' },
        { code: '+505', label: '+505 NI' },
        { code: '+507', label: '+507 PA' },
        { code: '+51', label: '+51 PE' },
        { code: '+34', label: '+34 ES' }
      ],
      rules: {
        required: (v) => !!v || 'Campo requerido',
        expirationAfterStart: (v) => {
          if (!v || !this.formData.invitation_date) return true
          return v >= this.formData.invitation_date || 'Debe ser mayor o igual a fecha inicio'
        },
        dateInReservation: (v) => {
          if (!v) return true
          const date = new Date(v)
          const start = new Date(this.reservation.start_date)
          const end = new Date(this.reservation.end_date)
          if (date < start || date > end) {
            return 'La fecha debe estar dentro del período de la reserva'
          }
          return true
        },
        numVehicles: (v) => {
          if (!v) return true
          const num = parseInt(v, 10)
          if (num < 1 || num > 3) return 'Debe estar entre 1 y 3 vehículos'
          return true
        }
      }
    }
  },
  created() {
    if (this.dialog) {
      this.initializeForm()
      this.fetchProviders()
    }
  },
  computed: {
    ...mapGetters(['providerHasParkingModule', 'getProviderParkingModule', 'getProfile']),
    isPrivate() {
      return !!(this.reservation && this.reservation.is_private_vehicles)
    },
    providerCompanyId() {
      if (this.getProfile && this.getProfile.id_company) {
        return this.getProfile.id_company
      }
      if (this.getProviderParkingModule && this.getProviderParkingModule.provider_empresa_id) {
        return this.getProviderParkingModule.provider_empresa_id
      }
      return null
    },
    availableSpaces() {
      const spaces = (this.reservation && this.reservation.reserved_spaces) || []
      return spaces.map(s => ({
        ...s,
        display_name: 'Cajón ' + (s.number || s.space_number) + (s.space_type_name ? ' - ' + s.space_type_name : '')
      }))
    }
  },
  watch: {
    'formData.parking_space_id'() {
      if (this.isPrivate) this.loadCapacity()
    },
    dialog(val) {
      if (val) {
        this.initializeForm()
        // Asegurar que reservation_id se establece correctamente
        if (this.reservation && this.reservation.id) {
          this.formData.reservation_id = this.reservation.id
        }
        this.fetchProviders()
      }
    },
    reservation(newVal) {
      if (newVal && newVal.id) {
        this.formData.reservation_id = newVal.id
      }
    }
  },
  methods: {
    addProviderEntry() {
      this.providerEntries.push({ key: ++this.entryKey, mode: 'existing', provider_id: null, first_name: '', last_name: '', email: '', phone_code: '+52', phone: '', plates: '', unit_specs: '' })
    },

    async loadCapacity() {
      const request = ++this.capacityRequest
      this.maxProviders = 0
      this.capacityError = ''
      const id = this.formData.parking_space_id
      if (!id) return
      this.loadingCapacity = true
      const headers = { authorization: 'Token ' + store.getters.getToken }
      try {
        const space = await axios.get(`https://empresa-service.intrare.app/Parking/spaces/${id}/`, { headers })
        const type = space.data.space_type
          ? await axios.get(`https://empresa-service.intrare.app/Parking/vehicle-types/${space.data.space_type}/`, { headers })
          : { data: { max_guests_per_space: 1 } }
        if (request !== this.capacityRequest) return

        const maxGuests = Number(type.data.max_guests_per_space)
        if (!Number.isInteger(maxGuests) || maxGuests < 1) throw new Error('Capacidad inválida')

        // Contar códigos existentes para este cajón en esta reserva
        const codesForSpace = await axios.get(
          `https://empresa-service.intrare.app/Parking/invitations/reservations/codes/list/`,
          {
            headers,
            params: {
              reservation_id: this.reservation.id,
              parking_space_id: id
            }
          }
        )
        if (request !== this.capacityRequest) return

        const existingCodes = Array.isArray(codesForSpace.data) ? codesForSpace.data.length : 0
        const availableSlots = maxGuests - existingCodes

        if (availableSlots <= 0) {
          this.capacityError = `Este cajón ya alcanzó su límite de ${maxGuests} código(s) QR.`
          this.maxProviders = 0
        } else {
          this.maxProviders = availableSlots
        }

        if (this.providerEntries.length > this.maxProviders) {
          this.capacityError = `Espacio disponible: ${this.maxProviders} proveedor(es).`
          this.providerEntries = this.providerEntries.slice(0, Math.max(1, this.maxProviders))
        }
      } catch (error) {
        if (request === this.capacityRequest) this.capacityError = 'No se pudo consultar la capacidad del cajón. Selecciónalo nuevamente para reintentar.'
      } finally {
        if (request === this.capacityRequest) this.loadingCapacity = false
      }
    },

    privateProvidersPayload() {
      const limit = this.maxProviders || 1
      if (this.providerEntries.length < 1) {
        throw new Error('Debes agregar al menos 1 proveedor')
      }
      if (this.providerEntries.length > limit) {
        throw new Error(`No puedes agregar más de ${limit} proveedor(es) para este cajón. Máximo permitido: ${limit}`)
      }
      const ids = new Set()
      return this.providerEntries.slice(0, limit).map((entry, index) => {
        if (entry.mode === 'existing') {
          if (!this.providers.some(p => p.id === entry.provider_id)) throw new Error(`Selecciona el proveedor ${index + 1}.`)
          if (ids.has(entry.provider_id)) throw new Error('Selecciona un proveedor diferente para cada QR.')
          ids.add(entry.provider_id)
          return { provider_id: entry.provider_id }
        }
        const data = {}
        ;['first_name', 'last_name', 'email', 'phone', 'plates', 'unit_specs'].forEach(field => { data[field] = entry[field].trim() })
        if (!data.first_name || (!data.email && !data.phone)) throw new Error(`Proveedor ${index + 1}: ingresa nombre y correo o teléfono.`)
        if (data.phone && !data.phone.startsWith('+')) {
          data.phone = (entry.phone_code || '+52') + data.phone
        }
        return data
      })
    },

    fetchProviders() {
      this.loadingProviders = true
      this.providers = []
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/Parking/providers/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      axios(config)
        .then((response) => {
          const rows = Array.isArray(response.data) ? response.data : (response.data.results || [])
          this.providers = rows.map(p => ({
            ...p,
            display_name: `${p.first_name || ''} ${p.last_name || ''}` + (p.plates ? ` (${p.plates})` : '')
          }))
        })
        .catch((error) => {
          console.error('Error cargando Transportistas:', error)
          handleApiError(error, store)
          this.providers = []
        })
        .finally(() => {
          this.loadingProviders = false
        })
    },

    onProviderSelected(providerId) {
      const provider = this.providers.find(p => p.id === providerId)
      if (provider) {
        this.formData.first_name = provider.first_name
        this.formData.last_name = provider.last_name || ''
        this.formData.email = provider.email || ''
        this.formData.plates = provider.plates || ''
        this.formData.unit_specs = provider.unit_specs || ''

        // Separar el lada del número: el teléfono en BD puede traer el lada incluido
        const phoneCode = provider.phone_code || '+52'
        let phone = provider.telephone || ''
        if (phone.startsWith(phoneCode)) {
          phone = phone.slice(phoneCode.length)
        }
        this.formData.phone_code = phoneCode
        this.formData.phone = phone
      }
    },

    initializeForm() {
      this.capacityRequest++
      this.maxProviders = 0
      this.loadingCapacity = false
      this.capacityError = ''
      this.providerEntries = []
      this.addProviderEntry()
      this.startMenu = false
      this.endMenu = false
      this.providerMode = 'existing'

      const today = new Date().toISOString().split('T')[0]

      this.formData = {
        reservation_id: this.reservation && this.reservation.id,
        parking_space_id: null,
        provider_id: null,
        invitation_date: today,
        expiration: (this.reservation && this.reservation.end_date) || today,
        subject: this.isPrivate ? 'Acceso de vehículo particular' : 'Acceso de Transportista',
        notes: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_code: '+52',
        phone: '',
        plates: '',
        unit_specs: '',
        activate_immediately: true,
        num_vehicles: 1
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr + 'T00:00:00')
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },

    formatTime(timeStr) {
      if (!timeStr) return ''
      // Esperando formato HH:MM:SS o HH:MM
      const parts = timeStr.split(':')
      return parts[0] + ':' + parts[1]
    },

    formatReservationPeriod() {
      if (!this.reservation) return ''
      
      let period = this.formatDate(this.reservation.start_date) + ' — ' + this.formatDate(this.reservation.end_date)
      
      // Agregar horario si existe
      if (this.reservation.start_time || this.reservation.end_time) {
        const startTime = this.reservation.start_time ? this.formatTime(this.reservation.start_time) : '--:--'
        const endTime = this.reservation.end_time ? this.formatTime(this.reservation.end_time) : '--:--'
        period += ' | ' + startTime + ' — ' + endTime
      }
      
      return period
    },

    async submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      if (!this.isPrivate && !this.formData.email && !this.formData.phone) {
        store.commit('snackbar_change_message', 'Debes proporcionar al menos email o teléfono')
        store.commit('snackbar_change_color', 'warning')
        store.commit('snackbar_activate_true')
        return
      }

      if (!this.formData.parking_space_id) {
        store.commit('snackbar_change_message', 'Selecciona un cajón')
        store.commit('snackbar_change_color', 'warning')
        store.commit('snackbar_activate_true')
        return
      }

      if (!this.isPrivate && this.providerMode === 'existing' && !this.formData.provider_id) {
        store.commit('snackbar_change_message', 'Selecciona un Transportista')
        store.commit('snackbar_change_color', 'warning')
        store.commit('snackbar_activate_true')
        return
      }

      if (this.loading) return
      let privateProviders
      if (this.isPrivate) {
        if (this.loadingCapacity) {
          store.commit('snackbar_change_message', 'Aún se carga la capacidad del cajón. Espera un momento.')
          store.commit('snackbar_change_color', 'warning')
          store.commit('snackbar_activate_true')
          return
        }
        if (this.capacityError) {
          store.commit('snackbar_change_message', 'Hay un error con la capacidad del cajón: ' + this.capacityError)
          store.commit('snackbar_change_color', 'error')
          store.commit('snackbar_activate_true')
          return
        }
        try { privateProviders = this.privateProvidersPayload() } catch (error) {
          store.commit('snackbar_change_message', error.message)
          store.commit('snackbar_change_color', 'warning')
          store.commit('snackbar_activate_true')
          return
        }
      }
      this.loading = true

      try {
        let payload = { ...this.formData }
        // Combinar lada + teléfono en un solo campo
        if (payload.phone) {
          payload.phone = payload.phone_code + payload.phone
        }
        delete payload.phone_code

        // Asegurar que reservation_id tenga el valor correcto
        if (!payload.reservation_id && this.reservation && this.reservation.id) {
          payload.reservation_id = this.reservation.id
        }

        // Convertir num_vehicles a número
        payload.num_vehicles = parseInt(payload.num_vehicles, 10) || 1

        // Si reutiliza Transportista, elimina los datos de nombres
        if (this.providerMode === 'existing') {
          delete payload.first_name
          delete payload.last_name
        } else {
          delete payload.provider_id
        }

        if (this.isPrivate) {
          payload = {
            reservation_id: this.reservation.id,
            parking_space_id: this.formData.parking_space_id,
            invitation_date: this.formData.invitation_date,
            expiration: this.formData.expiration,
            subject: this.formData.subject,
            activate_immediately: true,
            providers: privateProviders,
            num_vehicles: privateProviders.length
          }
        }

        payload.activate_immediately = true

        // Elimina campos vacíos
        Object.keys(payload).forEach(function(key) {
          if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
            delete payload[key]
          }
        })

        const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/Parking/invitations/reservations/codes/create/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          },
          data: payload
        }

        const response = await axios(config)
        
        // Mostrar éxito en snackbar
        store.commit('snackbar_change_message', 'Código QR creado exitosamente')
        store.commit('snackbar_change_color', 'success')
        store.commit('snackbar_activate_true')
        
        this.$emit('created', response.data)
      } catch (err) {
        // Usar el manejador centralizado de errores
        handleApiError(err, store)
      } finally {
        this.loading = false
      }
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

